"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccordionItemContext = void 0;
var _react = require("react");
var AccordionItemContext = /*#__PURE__*/(0, _react.createContext)({});
exports.AccordionItemContext = AccordionItemContext;